<template>
  <div id="shipmentsExport">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pb-5 px-5 mt-1">
      <div class="d-flex justify-space-between align-center pt-5">
        <h1>Dados Exportados NFEs</h1>
      </div>

      <div class="mt30"></div>

      <div class="d-flex mb-4 mt-3">
        <v-icon class="pr-1">mdi-information-outline</v-icon>
        <div class="info-message">Atenção, apenas os últimos 5 registros serão mantidos.</div>
      </div>

      <div class="table">
        <v-data-table
          :headers="headers"
          :items="reports"
          :loading="isLoading"
          :items-per-page="pageSize"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{
            'items-per-page-options': [],
            itemsPerPageText: ''
          }"
        >
          <template v-slot:[`item.initialDate`]="{ item }">
            {{ transformDate(item.initialDate) }}
          </template>
          <template v-slot:[`item.dateEnd`]="{ item }">
            {{ transformDate(item.dateEnd) }}
          </template>
          <template v-slot:[`item.requestDate`]="{ item }">
            {{ transformDateTime(item.requestDate) }}
          </template>
          <template v-slot:[`item.holidays`]="{ item }">
            <copy-to-clipboard-tooltip :text="formatHolidays(item.holidays)"></copy-to-clipboard-tooltip>
          </template>

          <template v-slot:[`item.actions`]="{ item, index }">
            <div>
              <template v-if="isDownloadLoading && index === loadingIndexItem">
                <div>
                  <v-progress-circular indeterminate color="secondary" size="20" width="3"></v-progress-circular>
                </div>
              </template>
              <v-tooltip top v-else>
                <template #activator="{ on, attrs }">
                  <v-icon
                    :disabled="checkIfIsAvaliableToDownload(item.statusName)"
                    @click="onDownloadClick(item.id, index)"
                    v-on="on"
                    v-bind="attrs"
                    >mdi-download</v-icon
                  >
                </template>
                Baixar
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="d-flex align-center pt-3">
          <v-pagination
            v-model="pageNumber"
            :length="totalPages"
            :total-visible="7"
            @input="onPageChange"
          ></v-pagination>
          <reload-button @click="getAllReports" />
        </div>
      </div>
    </v-card>

    <MessagesError
      :type="errorsType"
      :errors="errors"
      :error500="error500"
      @closeMessages="
        errors = [];
        error500 = null;
      "
    />
  </div>
</template>

<script>
import BreadCrumb from '../../../components/BreadCrumb.vue';
import { mapActions } from 'vuex';
import MessagesError from '../../../components/MessagesError.vue';
import { formatDate } from '@/handlers/DateHandler';
// import maskData from '@/utils/maskData';
import CopyToClipboardTooltip from '@/components/CopyToClipboardTooltip.vue';
import ReloadButton from '@/components/ReloadButton';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import maskData from '@/utils/maskData';

export default {
  name: 'ShipmentsExport',
  components: {
    BreadCrumb,
    MessagesError,
    CopyToClipboardTooltip,
    ReloadButton
  },
  data: () => ({
    isLoading: false,
    pageNumber: 1,
    totalPages: 1,
    pageSize: 10,
    reports: [],
    headers: [
      { text: 'DATA DA SOLICITAÇÃO', value: 'requestDate', align: 'start' },
      { text: 'NOME DO USUÁRIO', value: 'responsibleUserName' },
      { text: 'DATA INICIAL', value: 'initialDate' },
      { text: 'DATA FINAL', value: 'dateEnd' },
      { text: 'FERIADOS', value: 'holidays' },
      { text: 'STATUS', value: 'statusName' },
      { text: 'AÇÕES', value: 'actions' }
    ],
    date: null,
    isDatePickerVisible: false,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Embarques',
        disabled: false,
        to: '/shipments',
        exact: true
      },
      {
        text: 'Dados Exportados',
        disabled: true
      }
    ],
    loadingIndexItem: null,
    isDownloadLoading: false,
    initialDate: null,
    finalDate: null,
    menu1: false,
    menu2: false,
    activePicker: null,
    activePicker2: null,
    activePicker3: null,
    errorsType: null,
    errors: [],
    error500: null,
    dates: [],
    menu: false
  }),
  computed: {
    formattedInitialDate() {
      if (!this.initialDate) return '';
      const [year, month, day] = this.initialDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.finalDate) return '';
      const [year, month, day] = this.finalDate.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'DAY'));
    }
  },
  created() {
    this.getAllReports();
    this.handleFeedback();
  },
  methods: {
    ...mapActions('ReportStore', ['report', 'getReports', 'downloadReport']),
    checkIfIsAvaliableToDownload(statusName) {
      if (statusName.toLowerCase() === 'pronto para download') {
        return false;
      }
      return true;
    },
    save(date, index) {
      if (index === 1) {
        this.$refs.menu1.save(date);
      } else {
        this.$refs.menu2.save(date);
      }
    },
    checkForm() {
      if (this.initialDate === null || this.finalDate === null) {
        return false;
      } else {
        return true;
      }
    },
    async generateExport() {
      try {
        this.isLoading = true;
        const model = {
          initialDate: this.initialDate,
          dateEnd: this.finalDate,
          holidays: this.dates
        };
        await this.report(model);
        this.isLoading = false;
      } catch (err) {
        this.errors = ['Ops, algo deu errado'];
        this.errorsType = 'error';
      }
    },
    async getAllReports() {
      try {
        this.isLoading = true;
        this.reports = await this.getReports();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onDownloadClick(id, index) {
      try {
        this.loadingIndexItem = index;
        this.isDownloadLoading = true;
        await this.downloadReport(id);
        this.errorsType = 'success';
        this.errors = ['Download realizado com successo!'];
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingIndexItem = null;
        this.isDownloadLoading = false;
      }
    },
    handleFeedback() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },
    onDateClick(date) {
      var index = this.dates.findIndex((x) => x === date);

      if (index === -1) {
        this.dates.push(date);
      } else {
        this.dates.splice(index, 1);
      }
    },
    getFormattedDate(dt_string) {
      return formatDate(dt_string);
    },
    onCloseClick(date) {
      const index = this.dates.indexOf(date);
      this.dates.splice(index, 1);
    },
    transformDate(date) {
      return maskData(date);
    },
    transformDateTime(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    },
    formatHolidays(holydays) {
      const formattedHolidaysDates = holydays.map((holiday) => this.transformDate(holiday));
      const stringHolidays = formattedHolidaysDates.join(', ');
      return stringHolidays;
    },
    onItemsPerPageChange(pageSize) {
      this.pageSize = pageSize;
      //   this.getAllShippers();
    },
    onPageChange(pageNumber) {
      this.pageNumber = pageNumber;
      //this.getAllDeliveries();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-select__selections {
  padding-left: 35px !important;
}
::v-deep .v-pagination.v-pagination {
  justify-content: start;
  position: inherit;
  width: auto;
}
</style>
